export type SuccessModalConfig = {
  successCustomHeading: string | null;
  successCustomBody: string | null;
  successCustomCtaVerbiage: string | null;
  successCustomCtaUrl: string | null;
};

export type HandraiserEntryBase = {
  title: string;
  titleFr: string;
  campaignId: string;
  successModalConfig: SuccessModalConfig;
};

export type HandraiserEntryWithDerivativeCode = HandraiserEntryBase & {
  derivativeCode: string[];
  modelSelect?: never;
};

export type HandraiserEntryWithModelSelect = HandraiserEntryBase & {
  modelSelect: string[];
  derivativeCode?: never;
};

export type HandraiserEntry = HandraiserEntryWithDerivativeCode | HandraiserEntryWithModelSelect;

export type HandraiserEntryCABase = HandraiserEntryBase & {
  titleFr: string;
  successModalConfigFr: SuccessModalConfig;
};

export type HandraiserEntryCAWithDerivativeCode = HandraiserEntryCABase & {
  derivativeCode: string[];
  modelSelect?: never;
};

export type HandraiserEntryCAWithModelSelect = HandraiserEntryCABase & {
  modelSelect: string[];
  derivativeCode?: never;
};

export type HandraiserEntryCA =
  | HandraiserEntryCAWithDerivativeCode
  | HandraiserEntryCAWithModelSelect;

export type HandraiserConfig = {
  HANDRAISER_CONFIG_US: Record<string, HandraiserEntry>;
  HANDRAISER_CONFIG_CA: Record<string, HandraiserEntryCA>;
};

export const isCAEntry = (
  entry: HandraiserEntry | HandraiserEntryCA,
): entry is HandraiserEntryCA => {
  return 'titleFr' in entry;
};
